export default {"src":"/_next/static/media/info-illustration-03.080be600.svg","height":86,"width":236,"blurWidth":0,"blurHeight":0};